import React from 'react'

import GroupList from '../../components/pages/groupList'

const RoutingGroups = () => <GroupList purpose="routing" />

export default RoutingGroups
